import * as actionType from "../states"

const initialState = {
    data: {
        isCompleteMode: false
    }
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case actionType.SET_LOCAL_ZOOM:
            return {
                ...state,
                data: payload
            }

        default:
            return state
    }
}
